import { render, staticRenderFns } from "./TransportRemoveDialog.vue?vue&type=template&id=1d1e49ee&scoped=true"
import script from "./TransportRemoveDialog.vue?vue&type=script&lang=ts"
export * from "./TransportRemoveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e49ee",
  null
  
)

export default component.exports